import {connect} from "react-redux";
import {Component} from "react";
import * as React from "react";
import {Input, Label} from "reactstrap";

/**
 * Vlastní checkbox, jelikož současně používaný se nepodařilo dostatečně jednoduše přestylovat bez jeho úpravy.
 */
class CustomCheckbox extends Component {

    render() {
        const {onChange, value, label, title, disabled} = this.props;

        return <Label check className={disabled ? "disabled" : ""} title={title}>
            <Input autocomplete="off" type="checkbox" disabled={disabled} checked={value} onChange={onChange} />
            <span className="checkmark"/>
            <span className="label">{label}</span>
        </Label>;
    }
}

export default connect()(CustomCheckbox);
